import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import toast, { Toaster } from "react-hot-toast";
import "./AuthStyles.css";

const Register = () => {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [acceptTerms, setAcceptTerms] = useState(false);
  const navigate = useNavigate();

  // Register function
  const registerHandler = async (e) => {
    e.preventDefault();

    if (!username || !email || !password) {
      toast.error("Please fill all fields");
      return;
    }

    if (!acceptTerms) {
      toast.error("Please accept terms and conditions");
      return;
    }

    setIsLoading(true);

    try {
      const data = { username, email, password };

      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/users/register`,
        data
      );

      toast.success(res.data.msg || "Registration Successful");
      console.log("Register response:", res.data);
      navigate("/login");
    } catch (err) {
      console.error("Register error:", err);
      if (err.response && err.response.data && err.response.data.msg) {
        toast.error(err.response.data.msg);
      } else {
        toast.error("Something went wrong");
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="form-container">
      <Toaster position="top-right" toastOptions={{
        style: {
          borderRadius: '12px',
          background: '#333',
          color: '#fff',
        },
      }} />
      
      {/* Animated background elements */}
      <div className="bg-orb orb-1"></div>
      <div className="bg-orb orb-2"></div>
      <div className="bg-orb orb-3"></div>
      
      <div className="form">
        <div className="form-header">
          <div className="icon-wrapper">
            <i className="fa-solid fa-user-plus"></i>
          </div>
          <h2>Create Account</h2>
          <p className="subtitle">Sign up to get started</p>
        </div>

        <form onSubmit={registerHandler}>
          <div className="input-group">
            <div className="input-wrapper">
              <i className="fa-solid fa-user input-icon"></i>
              <input
                type="text"
                className="form-control"
                placeholder="Username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>
          </div>

          <div className="input-group">
            <div className="input-wrapper">
              <i className="fa-solid fa-envelope input-icon"></i>
              <input
                type="email"
                className="form-control"
                placeholder="Email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          </div>

          <div className="input-group">
            <div className="input-wrapper">
              <i className="fa-solid fa-lock input-icon"></i>
              <input
                type={showPassword ? "text" : "password"}
                className="form-control"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <i 
                className={`fa-solid ${showPassword ? 'fa-eye-slash' : 'fa-eye'} toggle-password`}
                onClick={() => setShowPassword(!showPassword)}
              ></i>
            </div>
          </div>

          <div className="form-options">
            <label className="remember-me terms-checkbox">
              <input 
                type="checkbox"
                checked={acceptTerms}
                onChange={(e) => setAcceptTerms(e.target.checked)}
              />
              <span>
                I agree to the <Link to="/terms" className="inline-link">Terms & Conditions</Link>
              </span>
            </label>
          </div>

          <button 
            type="submit" 
            className="auth-btn" 
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <i className="fa-solid fa-spinner fa-spin"></i>
                <span>Creating account...</span>
              </>
            ) : (
              <>
                <span>Create Account</span>
                <i className="fa-solid fa-arrow-right"></i>
              </>
            )}
          </button>

          <div className="divider">
            <span>or continue with</span>
          </div>

          {/* <div className="social-login">
            <button type="button" className="social-btn google">
              <i className="fa-brands fa-google"></i>
            </button>
            <button type="button" className="social-btn github">
              <i className="fa-brands fa-github"></i>
            </button>
            <button type="button" className="social-btn apple">
              <i className="fa-brands fa-apple"></i>
            </button>
          </div> */}

          <p className="form-footer">
            Already have an account? 
            <Link to="/login" className="link-primary">Sign in</Link>
          </p>
        </form>
      </div>
    </div>
  );
};

export default Register;